import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {IScreenComponentProps, screenComponent} from "../screenComponent";


interface IPreloaderProps extends IScreenComponentProps
{

}

import './Preloader.css';

class Preloader extends React.Component<IPreloaderProps, null>
{
    constructor(public props: IPreloaderProps)
    {
        super(props);
    }


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        if (! this.props.active) return null;

        return <div>preloader</div>
    }
}


/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {}
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(screenComponent()(Preloader));


// WEBPACK FOOTER //
// ./src/ts/app/screens/preloader/Preloader.tsx